import searchSuggestionService from "../services/searchSuggestionService";

export const CREATE_OR_UPDATE_SEARCH_SUGGESTION = "CREATE_OR_UPDATE_SEARCH_SUGGESTION";
export const CREATE_OR_UPDATE_SEARCH_SUGGESTION_SUCCESS = "CREATE_OR_UPDATE_SEARCH_SUGGESTION_SUCCESS";
export const CREATE_OR_UPDATE_SEARCH_SUGGESTION_ERROR = "CREATE_OR_UPDATE_SEARCH_SUGGESTION_ERROR";
export const CREATE_OR_UPDATE_SEARCH_SUGGESTION_RESET = "CREATE_OR_UPDATE_SEARCH_SUGGESTION_RESET";

export const GET_SEARCH_SUGGESTIONS = "GET_SEARCH_SUGGESTIONS";
export const GET_SEARCH_SUGGESTIONS_SUCCESS = "GET_SEARCH_SUGGESTIONS_SUCCESS";
export const GET_SEARCH_SUGGESTIONS_ERROR = "GET_SEARCH_SUGGESTIONS_ERROR";

export function createOrUpdateSearchSuggestionRecord(data) {
  return async (dispatch) => {
    dispatch(createOrUpdateSearchSuggestion());
    return await searchSuggestionService
      .createOrUpdateSearchSuggestion(data)
      
      .then((response) => dispatch(createOrUpdateSearchSuggestionSuccess(response)))
      .catch((error) => dispatch(createOrUpdateSearchSuggestionError(error)));
  };
}

export function createOrUpdateSearchSuggestion() {
  return {
    type: CREATE_OR_UPDATE_SEARCH_SUGGESTION,
  };
}

export function createOrUpdateSearchSuggestionSuccess(success) {
  return {
    type: CREATE_OR_UPDATE_SEARCH_SUGGESTION_SUCCESS,
    payload: { success },
  };
}

export function createOrUpdateSearchSuggestionError(error) {
  return {
    type: CREATE_OR_UPDATE_SEARCH_SUGGESTION_ERROR,
    payload: { error },
  };
}

export function createOrUpdateSearchSuggestionReset() {
  return {
    type: CREATE_OR_UPDATE_SEARCH_SUGGESTION_RESET,
  };
}

export function getSearchSuggestionsRecord(query) {
  return async (dispatch) => {
    dispatch(getSearchSuggestions());
    return await searchSuggestionService
      .getSearchSuggestions(query)
      
      .then((response) => dispatch(getSearchSuggestionsSuccess(response)))
      .catch((error) => dispatch(getSearchSuggestionsError(error)));
  };
}

export function getSearchSuggestions() {
  return {
    type: GET_SEARCH_SUGGESTIONS,
  };
}

export function getSearchSuggestionsSuccess(success) {
  return {
    type: GET_SEARCH_SUGGESTIONS_SUCCESS,
    payload: { success },
  };
}

export function getSearchSuggestionsError(error) {
  return {
    type: GET_SEARCH_SUGGESTIONS_ERROR,
    payload: { error },
  };
}